import { render, staticRenderFns } from "./spareRequirementsDetail.vue?vue&type=template&id=550c8284&scoped=true"
import script from "./spareRequirementsDetail.vue?vue&type=script&lang=js"
export * from "./spareRequirementsDetail.vue?vue&type=script&lang=js"
import style0 from "./spareRequirementsDetail.vue?vue&type=style&index=0&id=550c8284&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550c8284",
  null
  
)

export default component.exports